import { createSlice } from "@reduxjs/toolkit";
import { addDays } from "date-fns";
import _ from "lodash";

const initialState = {
  transactions: [],
  drawWinners: [],
  leaderboard: [],
  transactionFilters: {
    dateRange: [
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ],
    entryStatus: "",
    selectedChannel: "",
    rewardType: "",
    code: "",
    network: "",
    station: "",
    amount: "",
  },
  drawWinnersFilters: {
    dateRange: [
      {
        startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
        endDate: new Date().setHours(23, 59, 59, 0),
        key: "selection",
      },
    ],
    currentPage: 1,
    totalPages: 1,
  },
  leaderboardFilters: {
    dateRange: [
      {
        startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
        endDate: new Date().setHours(23, 59, 59, 0),
        key: "selection",
      },
    ],
  },
};

const entriesSlice = createSlice({
  name: "entries",
  initialState,
  reducers: {
    setTransactions(state, action) {
      state.transactions = action.payload;
    },
    setDrawWinners(state, action) {
      state.drawWinners = action.payload;
    },
    setLeaderboard(state, action) {
      const newData = action.payload;
      // Remove duplicates from existing data
      const filteredStateData = state.leaderboard.filter(
        (existingItem) =>
          !newData.some((newItem) => _.isEqual(existingItem, newItem))
      );

      // Concatenate filtered existing data with new data
      const updatedLeaderboard = [...filteredStateData, ...newData];

      const sorted = (updatedLeaderboard || [])?.sort((a, b) => {
        return b.loyaltyPoints - a.loyaltyPoints;
      });

      const sortedDate = (sorted || [])?.slice()?.map((item) => {
        return {
          position: sorted?.indexOf(item) + 1,
          name: item?.name,
          userId: item?.userId,
          location: item?.location,
          loyaltyPoints: item?.loyaltyPoints,
        };
      });

      state.leaderboard = sortedDate;
    },
    setLeaderboardFilters(state, action) {
      state.leaderboardFilters = action.payload;
    },
    setTransactionFilters(state, action) {
      state.transactionFilters = {...state.transactionFilters, ...action.payload}
    },
    setDrawWinnersFilters(state, action) {
      state.drawWinnersFilters = action.payload;
    },
    prepare: (payload) => ({
      payload,
    }),
  },
});

export const transactionsState = (state) => state.entries.transactions;
export const drawWinnersState = (state) => state.entries.drawWinners;
export const leaderboardState = (state) => state.entries.leaderboard;
export const leaderboardFiltersState = (state) =>
  state.entries.leaderboardFilters;

export const transactionFiltersState = (state) =>
  state.entries.transactionFilters;

export const drawWinnersFiltersState = (state) =>
  state.entries.drawWinnersFilters;

export const {
  setTransactions,
  setDrawWinners,
  setLeaderboard,
  setTransactionFilters,
  setDrawWinnersFilters,
  setLeaderboardFilters,
} = entriesSlice.actions;

export default entriesSlice.reducer;
